module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-all-900-normal.woff?9b6b73f9f3a35bfba27f3e656bd0c5ef";